import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { contactServices } from '@hero/services';
import { cleanObjectEmptyFields, createQueryKey } from '@hero/utils';

export const useGetContacts = (params = {}, queryOptions = {}) => {
  return useQuery(
    createQueryKey(QUERY_KEYS.useGetContactsKey, params),
    () => contactServices.getContacts(cleanObjectEmptyFields(params)),
    queryOptions
  );
};
